import { config } from '@/config/config';
import { ApiClient } from '@/utils/api/api-client';

export const publicSearchClient = new ApiClient(config.publicSearch.url);
